import { http } from "./httpServices";
import { OUTLET } from "./constants";

export function fetchAllParks() {
  return http.get(
    `${OUTLET}?searchText=${''}&page=${1}&limit=${20}&type=parks`
  );
}


export function fetchAllActiveParks() {
  return http.get(
    `${OUTLET}?searchText=${''}&page=${1}&limit=${20}&type=parks&isCommingsoon=${false}`
  );
}